/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SeriesRepetitionEnum = {
    ByCount: 'BY_COUNT',
    ByDate: 'BY_DATE',
    Unending: 'UNENDING'
} as const;
export type SeriesRepetitionEnum = typeof SeriesRepetitionEnum[keyof typeof SeriesRepetitionEnum];

